<template>
  <page-wrapper ref="pageEl" :title="title">
    <div v-show="false" class="header">
      <sc-button
        :route="createPackageButton.route"
        class="create-button"
        variant="primary"
        >{{ createPackageButton.text }}</sc-button
      >
    </div>
    <div class="wrapper">
      <div class="row mb-3">
        <div class="col-3">
          <div class="label mb-2">ชื่อแพ็กเกจ</div>
          <el-input v-model="packageName" />
        </div>
      </div>
      <div class="text-end">
        <sc-button variant="primary" @click="handleClickSearch"
          >ค้นหา</sc-button
        >
      </div>
      <div v-if="list.length">
        <p class="mb-2 mt-2">{{ totalCount }}</p>
        <div>
          <package-list-item
            v-for="item in list"
            :key="item.key"
            :value="item"
          ></package-list-item>
          <div v-if="list.length" class="text-end mt-4">
            <el-pagination
              :total="total"
              :size="10"
              :current-page="queryParams.page"
              background
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div v-else class="text-center p-5">
        <h3>ไม่มีข้อมูล</h3>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper"
import ScButton from "@/lib/components/ScButton"
import { baanRueJaiClient } from "@/dependencies"
import { Input, Pagination } from "element-ui"
import PackageListItem from "../components/PackageListItem"

export default {
  components: {
    PageWrapper,
    PackageListItem,
    ScButton,
    "el-input": Input,
    "el-pagination": Pagination,
  },
  data() {
    const title = "รายการ Ruejai Club Sale Package"
    const createPackageButton = {
      text: "เพิ่มแพ็กเกจ",
      route: { name: "RuejaiClubSalePackageCreatePage" },
    }
    const list = []
    const total = 0
    const packageName = null

    return {
      title,
      list,
      createPackageButton,
      packageName,
      total,
    }
  },
  computed: {
    totalCount() {
      const limit = 10
      const total = this.total.toLocaleString()
      const currentTotalItem = this.list.length
      const isLastPage = limit > currentTotalItem
      const currentPage = this.queryParams.page
      const end = (isLastPage ? total : currentPage * limit).toLocaleString()
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString()

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`
    },
    queryParams() {
      return {
        page: parseInt(this.$route.query.page, 10) || 1,
        name: this.$route.query.name || null,
      }
    },
  },
  watch: {
    "$route.query": async function routeQueryWatcher() {
      await this.setupData()

      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0
    },
  },
  mounted() {
    this.setup()
  },
  methods: {
    setup() {
      this.setupQuery()
      this.setupData()
    },
    setupQuery() {
      this.packageName = this.$route.query.name
    },
    setupData() {
      this.setupList()
    },
    async setupList() {
      const params = this.queryParams
      /* eslint-disable camelcase -- API response */
      const { total_count, items } = await this.fetchList(params)
      this.total = total_count
      /* eslint-enable camelcase */

      this.list = items.map((item) => {
        /* eslint-disable camelcase -- API response */
        const { id, subscription_package } = item

        const {
          id: subscriptionPackageId,
          name,
          price,
          billing_cycle: billingCycle,
          target,
          detail,
          image_url: imageUrl,
          original_Price: originalPrice,
          thumbnail_url: thumbnailUrl,
        } = subscription_package
        /* eslint-enable camelcase */

        const routeParams = {
          id,
          subscriptionPackageId,
        }

        const route = {
          name: "RuejaiClubSalePackageDetailPage",
          params: routeParams,
        }

        return {
          id,
          route,
          subscriptionPackageId,
          name,
          price,
          billingCycle,
          target,
          detail,
          imageUrl,
          originalPrice,
          thumbnailUrl,
        }
      })
    },
    async fetchList(params) {
      const response =
        await baanRueJaiClient.admin.ruejaiClub.salePackages.list(params)

      return response.data.result
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page },
      }

      this.$router.replace(route)
    },
    async handleClickSearch() {
      const route = {
        name: this.$route.name,
        query: {
          ...this.$route.query,
          page: 1,
          name: this.packageName,
        },
      }

      this.$router.replace(route)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  display: row;
  flex-flow: row nowrap;
  justify-content: space-between;

  padding: 30px;
  border-bottom: $border;
}

.wrapper {
  padding: ($space / 2) $space;
}
</style>
